import React, {FC} from 'react';
import Helmet from 'react-helmet';
import {
  ShowToastType,
  ToastContextProvider,
} from '../../Toast/ToastContextProvider';
import HelpdeskArticlePageUI from '../../ui/Helpdesk/HelpdeskArticlePage/HelpdeskArticlePageUI';
import {ClientSideNavigationProvider} from '../../ui/Navigation/ClientSideLink/ClientSideLink';
import SeoFaqStructuredJson from './SeoFaqStructuredJson';
import {filterHiddenSections} from './hiddenSections';
import useFilterVipSections from './hooks/useFilterVipSectionts';
import useRedirectVipOnlySection from './hooks/useRedirectVipOnlySection';
import {HelpCenterArticlePageData, HelpCenterPageProps} from './types';

const HelpCenterArticlePage: FC<
  HelpCenterPageProps<HelpCenterArticlePageData> & {
    showToast: ShowToastType;
  }
> = props => {
  useRedirectVipOnlySection(
    props.isVip,
    props.isCoinsActive,
    props.activeSectionId,
    props.navigateClient,
  );
  const sections = useFilterVipSections(
    props.isVip,
    props.isCoinsActive,
    props.sections,
  ).filter(filterHiddenSections);

  return (
    <ToastContextProvider showToast={props.showToast}>
      <Helmet
        title={props.translations.articlePage.seo_page_title}
        meta={[
          {
            name: 'description',
            content: props.translations.articlePage.seo_page_description,
          },
          {name: 'robots', content: 'index, follow'},
        ]}
        link={[{rel: 'canonical', href: props.canonicalUrl}]}
      />
      <ClientSideNavigationProvider navigateClient={props.navigateClient}>
        <HelpdeskArticlePageUI
          locale={props.locale}
          activeArticle={props.activeArticle}
          sections={sections}
          translations={props.translations}
          relatedArticles={props.relatedArticles}
          activeSectionId={props.activeSectionId}
          endpoints={props.endpoints}
          isShowOldHelpCenterEnabled={props.isShowOldHelpCenterEnabled}
          CloudflareTurnstile={props.CloudflareTurnstile}
          isDesktop={props.isDesktop}
        />
      </ClientSideNavigationProvider>
      {props.activeArticle && (
        <SeoFaqStructuredJson articles={[props.activeArticle]} />
      )}
    </ToastContextProvider>
  );
};

export default HelpCenterArticlePage;
